import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import Card from '@material-ui/core/Card'
import Badge from 'ui/components/badge'
import Typography from '@material-ui/core/Typography'
import useStyles from './styles'
import { getCountries } from 'services/config/selectors'

const BusinessCard = props => {
  const { nif, company, country } = props

  const classes = useStyles()

  const countries = useSelector(getCountries)
  const countryData = countries.find(
    item => parseInt(item.id) === parseInt(country),
  )

  return (
    <Card elevation={1} className={classes.root}>
      <Typography variant="body1" className={classes.nif}>
        {nif}
      </Typography>
      <Typography variant="h1" className={classes.company}>
        {company}
      </Typography>
      <Badge type="attached" label={countryData.name} />
    </Card>
  )
}

BusinessCard.propTypes = {
  nif: PropTypes.string,
  company: PropTypes.string,
  country: PropTypes.string,
}

export default BusinessCard
